import script from "./SalesmanReturnOrderManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesmanReturnOrderManagement.vue?vue&type=script&setup=true&lang=js"

import "./SalesmanReturnOrderManagement.vue?vue&type=style&index=0&id=608201c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-608201c9"]])

export default __exports__